export default {
  users: [],
  user: {},
  dynamicPageContent: {},
};
